import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=1615bb66&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1615bb66')) {
      api.createRecord('1615bb66', component.options)
    } else {
      api.reload('1615bb66', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=1615bb66&", function () {
      api.rerender('1615bb66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hpz7ha947wRJ/JS/offershelp.vue"
export default component.exports